import React, { Component } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';
import * as userActions from 'modules/user';

import { AdminUserList } from 'components';

let SEARCH_VALUE = '';
class CtAdminUserList extends Component {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = ['searchAll', 'serviceNo', 'serviceName', 'userNo', 'userEmail', 'userPhone'];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      //data: [],
      //pages: null,
      fromNowRegDate: false,
      fromNowPasswdUpdateDate: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      searchText: searchTextData,
      tempFilter: {}
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData } = this.props;

    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData
    ) {
      this.getUser();
    }
  }

  getUser = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { UserActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize
        };

        await UserActions.getUser(params);
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  //로그인 실패 필터
  loginFailFilter = data => {
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['loginFailArray'] === 'undefined') {
      filter['loginFailArray'] = [data.value];
    } else {
      const indexArray = filter['loginFailArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['loginFailArray'].push(data.value);
      } else {
        filter['loginFailArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['loginFailArray'].length === 0 && delete filter['loginFailArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };
  //활성화 필터
  userActivedFilter = data => {
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['userActivedArray'] === 'undefined') {
      filter['userActivedArray'] = [data.value];
    } else {
      const indexArray = filter['userActivedArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['userActivedArray'].push(data.value);
      } else {
        filter['userActivedArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['userActivedArray'].length === 0 && delete filter['userActivedArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //삭제 여부 필터
  userEnabledFilter = data => {
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['userEnabledArray'] === 'undefined') {
      filter['userEnabledArray'] = [data.value];
    } else {
      const indexArray = filter['userEnabledArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['userEnabledArray'].push(data.value);
      } else {
        filter['userEnabledArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['userEnabledArray'].length === 0 && delete filter['userEnabledArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { UserActions } = this.props;
    UserActions.changeParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { UserActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = ['searchAll', 'serviceNo', 'serviceName', 'userNo', 'userEmail', 'userPhone'];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        UserActions.changeParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  //체크 취소
  cancleCheck = () => {
    const { UserActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // // 개별 필터
  // handleChangeFilter = (column, value, isMulti) => {
  //   const { UserActions, paramData } = this.props;
  //   const filter = paramData.get('filter').toJS();

  //   // 멀티 선택 필터
  //   if (isMulti) {
  //     if (typeof filter[column] === 'undefined') {
  //       filter[column] = value;
  //     } else if (Number(filter[column]) === Number(value)) {
  //       delete filter[column];
  //     } else {
  //       if (Number(value) & Number(filter[column])) {
  //         filter[column] = Number(filter[column]) - Number(value);
  //       } else {
  //         filter[column] = Number(filter[column]) + Number(value);
  //       }
  //     }
  //     // 단일 선택 필터
  //   } else {
  //     if (filter[column] === value) {
  //       delete filter[column];
  //     } else {
  //       filter[column] = value;
  //     }
  //   }

  //   this.setState({ currentPage: 0 });
  //   UserActions.changeParam({
  //     name: 'filter',
  //     value: fromJS(filter)
  //   });
  // };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { UserActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    UserActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { UserActions } = this.props;

    UserActions.changeParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { UserActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    UserActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      loading,
      fromNowRegDate,
      fromNowPasswdUpdateDate,
      currentPage,
      pageSize,
      fitRowCount,
      searchType,
      searchText,
      tempFilter
    } = this.state;
    const { isAuth, userData, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData, takeSearchValue } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      userEnabledFilter,
      userActivedFilter,
      loginFailFilter,
      handleChangeFilter,
      handleChangeDateFilter,
      handleInitFilter,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();

    const fromNowClass = [];
    if (fromNowRegDate) {
      fromNowClass.push('from-now-reg-date');
    }
    if (fromNowPasswdUpdateDate) {
      fromNowClass.push('from-now-passwd-update-date');
    }

    let respData = {};
    if (userData && Map.isMap(userData)) {
      respData = userData.toJS();
    }

    if (
      respData &&
      respData.result === 1 &&
      respData.success &&
      Array.isArray(respData.success) &&
      respData.success.length > 0
    ) {
      if (respData.success[0].rnum) {
        respData.success.map((userData, index) => {
          // 로그인 실패 데이터 처리
          if (userData.loginFail === 1) {
            respData.success[index].loginFail =
              defineMessages(formatMessage({ id: 'UserEdit_17', defaultMessage: '잠김' })) +
              ' (' +
              userData.loginFailCount +
              defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' })) +
              ')';
          } else {
            respData.success[index].loginFail =
              defineMessages(formatMessage({ id: 'UserEdit_14', defaultMessage: '정상' })) +
              ' (' +
              userData.loginFailCount +
              defineMessages(formatMessage({ id: 'TargetDetail_32', defaultMessage: '회' })) +
              ')';
          }
        });
      }
    } else {
      // 응답 데이터 오류
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      { key: 0, text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })), value: 'searchAll' },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'AdminLog_4', defaultMessage: '서비스No' })),
        value: 'serviceNo'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'AdminLog_19', defaultMessage: '서비스명' })),
        value: 'serviceName'
      },
      { key: 3, text: 'No', value: 'userNo' },
      {
        key: 4,
        text: defineMessages(formatMessage({ id: 'AdminUserList_2', defaultMessage: '이메일' })),
        value: 'userEmail'
      },
      {
        key: 5,
        text: defineMessages(formatMessage({ id: 'AdminUserList_3', defaultMessage: '연락처' })),
        value: 'userPhone'
      }
    ];

    return (
      <AdminUserList
        isAuth={isAuth}
        fromNowClass={fromNowClass}
        manual
        data={respData.success}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          takeSearchValue: takeSearchValue,
          searchTextRef: searchTextRef,
          paramData: paramData,
          tempFilter: tempFilter
        }}
        // 필터
        userEnabledFilter={userEnabledFilter}
        userActivedFilter={userActivedFilter}
        loginFailFilter={loginFailFilter}
        cancleCheck={cancleCheck}
        filterClose={filterClose}
        executeFilter={executeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
        // 교육 활성 여부
        isEdu={commonVar.isEdu}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    userData: state.user.get('data'),
    needReload: state.user.get('needReload'),
    totalPages: state.user.get('totalPages'),
    totalCount: state.user.get('totalCount'),
    paramData: state.user.get('param'),
    isAuth: state.user.get('isAuth')
  };
};

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminUserList));



// WEBPACK FOOTER //
// ./src/script/containers/admin/user/CtAdminUserList.js